import { render, staticRenderFns } from "./LearningGoalsForBlockCard.vue?vue&type=template&id=5d7fa14a&"
import script from "./LearningGoalsForBlockCard.vue?vue&type=script&lang=js&"
export * from "./LearningGoalsForBlockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports